<template>
  <b-card
    no-body
    class="custom-counter"
  >
    <div class="d-flex justify-content-between">
      <div class="font-weight-bolder title">
        Valör
      </div>
      <div class="pr-2 position-absolute position-right-0">
        <b-form-checkbox
          switch
          @change="changeType"
        >
          Aylık
        </b-form-checkbox>
      </div>
    </div>
    <div class="d-flex align-items-center justify-content-between">
      <div>
        <div class="font-weight-bold font-small-2 sub-title text-muted">
          {{ dataItem.type === 'ytd'? 'Yıllık' : 'Aylık' }}
        </div>
        <div class="font-medium-4 font-weight-bolder text-dark">
          <div
            v-if="isLoading"
            class="text-left d-flex align-items-center mt-1"
          >
            <b-spinner
              variant="muted"
              small
            />
            <div
              class="font-small-4 font-weight-normal text-muted"
              style="margin-left: 5px"
            >
              Yükleniyor
            </div>
          </div>
          <template v-else>
            <span v-if="dataItem.type === 'ytd'">
              {{ dataItem.ytd | toNumber }} Gün
            </span>
            <span v-if="dataItem.type === 'mtd'">
              {{ dataItem.mtd | toNumber }} Gün
            </span>
          </template>
        </div>
      </div>
      <div>
        <div
          class="bg-light-warning icon d-flex align-items-center justify-content-center rounded-pill text-white"
        >
          <FeatherIcon
            icon="CalendarIcon"
            size="18"
          />
        </div>
      </div>
    </div>
    <div class="refresh-button position-absolute position-top-0 position-right-0">
      <b-button
        v-if="refreshData"
        v-b-tooltip.hover.top="'Veriyi Güncelle'"
        pill
        class="btn-icon"
        size="sm"
        variant="light"
        @click="refreshData('counters')"
      >
        <FeatherIcon icon="RefreshCwIcon" />
      </b-button>
    </div>
  </b-card>
</template>
<script>
import {
  BCard, BButton, BSpinner, VBTooltip, BFormCheckbox,
} from 'bootstrap-vue'

export default {
  name: 'CounterSaleValueDateAvg',
  components: {
    BCard,
    BButton,
    BSpinner,
    BFormCheckbox,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    dataItem: {
      type: Object,
      required: true,
    },
    refreshData: {
      type: Function,
      default: null,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dashboardData() {
      return this.$store.getters['liveSalesDashboard/dashboardData']
    },
  },
  methods: {
    changeType() {
      if (this.dashboardData.counters.saleValueDateAVG.type === 'ytd') {
        this.dashboardData.counters.saleValueDateAVG.type = 'mtd'
      } else {
        this.dashboardData.counters.saleValueDateAVG.type = 'ytd'
      }
    },
  },
}
</script>
<style>
.refresh-button{
  margin-top: -10px !important;
  margin-right: -10px !important;
}
.refresh-button .btn{
  border:1px solid #ddd
}
</style>
